import { render } from "./Input.vue?vue&type=template&id=89c01fa4&scoped=true&bindings={\"name\":\"props\",\"label\":\"props\",\"placeholder\":\"props\",\"errorMessage\":\"props\",\"meta\":\"props\"}"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"

import "./Input.vue?vue&type=style&index=0&id=89c01fa4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-89c01fa4"

export default script